setLiveAccessEventListError